import styled from "styled-components";
import { InputLabel, Autocomplete } from "@mui/material";

export const StyledMUIAutoComplete = styled(Autocomplete)`
  & .MuiAutocomplete-inputRoot {
      width:100%;
      color: #707070;
      font: normal normal normal 16px/17px Open Sans;
    .MuiAutocomplete-input{
        height: 10px;
        width:100%;
    }
  }
`;

export const SelectLabel = styled(InputLabel)`
  text-align: left;
  font: normal normal normal 22px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
  text-transform: capitalize;
`;